import React from 'react';
import { DataTable, SectionHeader, StatusPill } from '../components';

export function CustomersPage({ rows, dashboard }) {
  const isLive = dashboard?.mode === 'live';
  return (
    <div>
      <SectionHeader
        title="Customers"
        subtitle={`${rows.customers?.length || 0} ${rows.customers?.length === 1 ? 'entry' : 'entries'}${isLive ? '' : ' · sample data'}`}
      />
      <DataTable
        testid="dash-customers-table"
        rows={rows.customers}
        emptyText="No customers yet."
        columns={[
          { key: 'name',   label: 'Name',   nowrap: true },
          { key: 'email',  label: 'Email' },
          { key: 'type',   label: 'Type',   nowrap: true },
          { key: 'ltv',    label: 'LTV',    nowrap: true,
            render: r => `€${Number(r.ltv || 0).toFixed(2)}` },
          { key: 'joined', label: 'Joined', nowrap: true,
            render: r => (r.joined || '').slice(0, 10) },
          { key: 'status', label: 'Status', render: r => <StatusPill value={r.status} /> },
        ]}
      />
    </div>
  );
}
